    // src/App.js
    // vAPP-HRM-150
// - HRM Opdrachten toegevoegd vóór Aanvragen
    // - CAO's in HRM-menu verplaatst naar direct onder Mijn Actiesignalen
    // - CAO's toegevoegd als zelfstandige HRM-functie
    // - Linkermenu iets verbreed zodat menuteksten ook met verticale scrollbalk volledig leesbaar blijven
    // - login.staffiq.nl uitgesloten van automatische tenant-afleiding
    // - Beschikbaarheid boven Planning gezet onder HRM
    // - Menu item Help toegevoegd onder Instellingen
    // - Route /help toegevoegd
    // - Vacatures teruggezet tussen Aanvragen en Plaatsingen in het HRM-menu en route hersteld
    // - HRM-menu blijft actief bij HRM-routes
    // - Handmatig wisselen tussen CRM en HRM blijft mogelijk op dezelfde route
    // - Gebruikerslogboek: session_key, heartbeat en logout toegevoegd
    // - Bedrijfscode-selectie toegevoegd bij CRM/HRM
    // - Bedrijfscodepopup opent alleen nog via het bedrijfscodeblok
    // - Bedrijfscodes worden op naam getoond
    // - Bedrijfscode-scope meldt wijziging aan geopende pagina's
    // - Login-tenant wordt automatisch afgeleid uit subdomein, bijvoorbeeld partner.staffiq.nl → partner

    import staffiqLogo from "./assets/staffiq-logo.png";
    import Login from "./pages/Login";
    import { useState, useEffect, useRef } from "react";
    import React from "react";
    import { BrowserRouter, Routes, Route, NavLink, useLocation } from "react-router-dom";

    import Organisaties from "./pages/Organisaties";
    import OrganisatieDetail from "./pages/OrganisatieDetail";
    import Contactpersonen from "./pages/Contactpersonen";
    import NotitiesTaken from "./pages/NotitiesTaken";
    import Documenten from "./pages/Documenten";
    import Projectbeheer from "./pages/Projectbeheer";
    import Facturen from "./pages/Facturen";
    import Offertes from "./pages/Offertes";
    import Instellingen from "./pages/Instellingen";
    import Help from "./pages/Help"; // ✅ nieuw
    import Actiecentrum from "./pages/Actiecentrum";
    import MijnActiesignalen from "./pages/MijnActiesignalen";
    import Akkoord from "./pages/Akkoord";
    import Personeel from "./pages/Personeel";
    import Aanvragen from "./pages/Aanvragen";
    import Opdrachten from "./pages/Opdrachten";
    import Vacatures from "./pages/Vacatures";
    import Plaatsingen from "./pages/Plaatsingen";
    import MatchingPersoneel from "./pages/MatchingPersoneel";
    import MatchingRelaties from "./pages/MatchingRelaties";
    import Planning from "./pages/Planning";
    import Beschikbaarheid from "./pages/Beschikbaarheid";
    import CAOs from "./pages/CAOs";
    import WerkbonOplevering from "./pages/WerkbonOplevering";
    import WerkbonnenOverzicht from "./pages/WerkbonnenOverzicht";
    import Opdrachtvoortgang from "./pages/Opdrachtvoortgang";
    import Opdrachtenplanning from "./pages/Opdrachtenplanning";

    function Layout({ children, onLogout, currentUser, staffiqProfile = "ALL" }) {
      const ASIDE_W = 220;
      const MOBILE_BREAKPOINT = 900;

      const role = (currentUser?.role || "user").toLowerCase();
      const isAdmin = role === "admin";

      const normalizedProfile = String(staffiqProfile || "ALL").toUpperCase();

      const availableModules =
        normalizedProfile === "ALL"
          ? ["CRM", "MKB", "HRM"]
          : ["CRM", "MKB", "HRM"].includes(normalizedProfile)
            ? [normalizedProfile]
            : ["ERP"];

      const fixedModule = availableModules.length === 1 ? availableModules[0] : "";

      function companyCodeLabel(code) {
        return String(code?.name || code?.code || "").trim() || `Bedrijfscode ${code?.id || ""}`;
      }

      function selectedCompanyCodeText() {
        if (!companyCodes.length) return "Bedrijfscode laden...";
        if (!selectedCompanyCodeIds.length) return "Geen bedrijfscode";
        if (selectedCompanyCodeIds.length === companyCodes.length) return "Alle bedrijfscodes";

        const names = companyCodes
          .filter((c) => selectedCompanyCodeIds.map(String).includes(String(c.id)))
          .map((c) => companyCodeLabel(c))
          .filter(Boolean);

        if (names.length <= 2) return names.join(", ");
        return `${names.length} bedrijfscodes`;
      }

      function storeCompanyScope(ids) {
        const clean = (ids || []).map((x) => String(x)).filter(Boolean);
        const joined = clean.join(",");

        try {
          sessionStorage.setItem("staffiq_company_code_ids", joined);
          localStorage.setItem("staffiq_company_code_ids", joined);
        } catch {}

        // Zorg dat pagina's die al geopend zijn opnieuw kunnen laden zodra
        // de bedrijfscode-scope beschikbaar is. Dit voorkomt een leeg grid
        // direct na inloggen bij gewone gebruikers.
        try {
          window.dispatchEvent(
            new CustomEvent("staffiq-company-scope-changed", {
              detail: { company_code_ids: clean },
            })
          );
        } catch {}
      }

      async function loadCompanyScope() {
        try {
          setCompanySelectorError("");

          const token =
            sessionStorage.getItem("token") ||
            localStorage.getItem("token") ||
            "";

          const res = await fetch("/api/company-scope", {
            headers: {
              "Content-Type": "application/json",
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
              ...buildActivityHeaders(),
            },
          });

          const data = await res.json().catch(() => ({}));

          if (!res.ok) {
            throw new Error(data?.error || "Bedrijfscodes konden niet worden geladen.");
          }

          const codes = Array.isArray(data.company_codes)
            ? data.company_codes.filter((c) => c?.active !== false)
            : [];
          const selected = Array.isArray(data.selected_company_code_ids)
            ? data.selected_company_code_ids.map(String)
            : codes.map((c) => String(c.id));

          setCompanyCodes(codes);
          setSelectedCompanyCodeIds(selected);
          storeCompanyScope(selected);
        } catch (err) {
          setCompanySelectorError(err?.message || "Bedrijfscodes konden niet worden geladen.");
          setCompanyCodes([]);
          setSelectedCompanyCodeIds([]);
          storeCompanyScope([]);
        }
      }

      async function saveCompanyScope(ids = selectedCompanyCodeIds) {
        try {
          setCompanySelectorError("");
          setCompanySelectorFlash("");

          const token =
            sessionStorage.getItem("token") ||
            localStorage.getItem("token") ||
            "";

          const clean = (ids || []).map((x) => String(x)).filter(Boolean);

          const res = await fetch("/api/company-scope", {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
              ...buildActivityHeaders(),
            },
            body: JSON.stringify({
              company_code_ids: clean,
            }),
          });

          const data = await res.json().catch(() => ({}));

          if (!res.ok) {
            throw new Error(data?.error || "Bedrijfscode-selectie opslaan mislukt.");
          }

          const saved = Array.isArray(data.selected_company_code_ids)
            ? data.selected_company_code_ids.map(String)
            : clean;

          setSelectedCompanyCodeIds(saved);
          storeCompanyScope(saved);
          setCompanySelectorFlash("Bedrijfscode-selectie opgeslagen ✅");
          setTimeout(() => setCompanySelectorFlash(""), 1600);
        } catch (err) {
          setCompanySelectorError(err?.message || "Bedrijfscode-selectie opslaan mislukt.");
        }
      }

      function toggleCompanyCode(id) {
        const key = String(id);

        setSelectedCompanyCodeIds((prev) => {
          const current = prev.map(String);
          if (current.includes(key)) {
            const next = current.filter((x) => x !== key);
            return next.length ? next : current;
          }

          return [...current, key];
        });
      }

      const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);
      const [menuOpen, setMenuOpen] = useState(false);
      const [companyCodes, setCompanyCodes] = useState([]);
      const [selectedCompanyCodeIds, setSelectedCompanyCodeIds] = useState([]);
      const [companySelectorOpen, setCompanySelectorOpen] = useState(false);
      const [companySelectorError, setCompanySelectorError] = useState("");
      const [companySelectorFlash, setCompanySelectorFlash] = useState("");
      const [actionCenterCount, setActionCenterCount] = useState(0);

      async function loadActionCenterCount() {
        try {
          const res = await fetch("/api/action-center/items?status=open", { headers: { "Content-Type": "application/json", ...buildActivityHeaders() } });
          const data = await res.json().catch(() => []);
          setActionCenterCount(res.ok && Array.isArray(data) ? data.length : 0);
        } catch { setActionCenterCount(0); }
      }

      function moduleForPath(pathname) {
        const path = String(pathname || "").toLowerCase();

        if (fixedModule) return fixedModule;

        const hrmRoutes = [
          "/personeel",
          "/matching-personeel",
          "/matching-relaties",
          "/opdrachten",
          "/aanvragen",
          "/vacatures",
          "/plaatsingen",
          "/caos",
          "/planning",
          "/beschikbaarheid",
        ];

        const mkbRoutes = [
          "/projectbeheer",
          "/offertes",
          "/facturen",
          "/werkbon-oplevering",
          "/werkbonnen",
          "/opdrachtvoortgang",
          "/opdrachtenplanning",
        ];

        if (hrmRoutes.some((route) => path === route || path.startsWith(`${route}/`))) return "HRM";
        if (mkbRoutes.some((route) => path === route || path.startsWith(`${route}/`))) return "MKB";

        // Relaties, contactpersonen, notities, documenten, help en instellingen
        // komen in meerdere menu's voor. Bij deze routes blijft de handmatig
        // gekozen menubalk daarom actief.
        return "";
      }


      const [activeModule, setActiveModule] = useState(() => {
        const routeModule = moduleForPath(window.location.pathname);
        if (routeModule) return routeModule;

        try {
          const saved = sessionStorage.getItem("staffiq_active_module");
          if (availableModules.includes(saved)) return saved;
        } catch {}

        return availableModules[0] || "CRM";
      });

      const location = useLocation();
      const mainRef = useRef(null);

      const isCrmModule = activeModule === "CRM";
      const isMkbModule = activeModule === "MKB";
      const isHrmModule = activeModule === "HRM";

      function switchModule(moduleName, options = {}) {
        const nextModule = availableModules.includes(moduleName)
          ? moduleName
          : availableModules[0] || "CRM";

        setActiveModule(nextModule);

        try {
          sessionStorage.setItem("staffiq_active_module", nextModule);
          window.dispatchEvent(
            new CustomEvent("staffiq-active-menu-changed", {
              detail: { active_module: nextModule },
            })
          );
        } catch {}

        if (options.openCompanySelector === true) {
          setCompanySelectorOpen(true);
        }
      }

      useEffect(() => {
        loadCompanyScope();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [currentUser?.id]);

      useEffect(() => {
        loadActionCenterCount();
        const refresh = () => loadActionCenterCount();
        window.addEventListener("staffiq-company-scope-changed", refresh);
        window.addEventListener("staffiq-action-center-changed", refresh);
        return () => {
          window.removeEventListener("staffiq-company-scope-changed", refresh);
          window.removeEventListener("staffiq-action-center-changed", refresh);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [currentUser?.id]);

      useEffect(() => {
        if (!availableModules.includes(activeModule)) {
          switchModule(availableModules[0] || "CRM");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [normalizedProfile]);

      useEffect(() => {
        function onResize() {
          const mobile = window.innerWidth <= MOBILE_BREAKPOINT;
          setIsMobile(mobile);

          if (!mobile) {
            setMenuOpen(false);
          }
        }

        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
      }, []);

    useEffect(() => {
        if (isMobile) {
          setMenuOpen(false);
        }
      }, [location.pathname, isMobile]);

    useEffect(() => {
        // Alleen bij een echte routewisseling de module automatisch zetten.
        // Daardoor kun je op dezelfde pagina handmatig tussen CRM en HRM wisselen.
        const routeModule = moduleForPath(location.pathname);

        if (routeModule) {
          switchModule(routeModule);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [location.pathname]);

      useEffect(() => {
        // Bij wisselen van programma/module altijd terug naar boven.
        // Maar: op smartphone mag het menu NIET sluiten als je alleen wisselt tussen CRM/HRM.
        requestAnimationFrame(() => {
          try {
            window.scrollTo({ top: 0, left: 0, behavior: "auto" });
          } catch {}

          try {
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
          } catch {}

          try {
            mainRef.current?.scrollTo?.({
              top: 0,
              left: 0,
              behavior: "auto",
            });
          } catch {}
        });
      }, [location.pathname, activeModule]);

      return (
        <div style={{ display: "flex", height: "100dvh", width: "100%", overflow: "hidden", position: "relative" }}>
          {/* MOBIELE TOPBALK */}
          {isMobile && (
            <button
              onClick={() => setMenuOpen(true)}
              aria-label="Menu openen"
              style={{
                position: "fixed",
                top: 12,
                left: 12,
                zIndex: 1200,
                border: "none",
                borderRadius: 10,
                background: "#0f2a3a",
                color: "white",
                padding: "10px 12px",
                fontSize: 22,
                lineHeight: 1,
                cursor: "pointer",
                boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
              }}
            >
              ☰
            </button>
          )}

          {/* MOBIELE OVERLAY ACHTER MENU */}
          {isMobile && menuOpen && (
            <div
              onClick={() => setMenuOpen(false)}
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.35)",
                zIndex: 1090,
              }}
            />
          )}

          {/* MENU */}
          <aside
            style={{
              width: ASIDE_W,
              flex: `0 0 ${ASIDE_W}px`,
              padding: 16,
              background: "#0f2a3a",
              color: "white",
              boxSizing: "border-box",
              overflowY: "auto",
              overflowX: "hidden",
              display: "flex",
              flexDirection: "column",
              height: "100dvh",

              position: isMobile ? "fixed" : "relative",
              top: 0,
              left: 0,
              zIndex: isMobile ? 1100 : "auto",
              transform: isMobile ? (menuOpen ? "translateX(0)" : "translateX(-100%)") : "translateX(0)",
              transition: "transform 0.25s ease",
              boxShadow: isMobile ? "2px 0 16px rgba(0,0,0,0.25)" : "none",
            }}
          >
            {isMobile && (
              <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
                <button
                  onClick={() => setMenuOpen(false)}
                  aria-label="Menu sluiten"
                  style={{
                    border: "none",
                    background: "transparent",
                    color: "white",
                    fontSize: 28,
                    lineHeight: 1,
                    cursor: "pointer",
                    padding: 0,
                  }}
                >
                  ×
                </button>
              </div>
            )}

            <div>
              <div style={{ textAlign: "center", marginBottom: 20 }}>
                <img
                  src={staffiqLogo}
                  alt="StaffIQ"
                  style={{
                    height: 65,
                    marginBottom: 8,
                  }}
                />

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "32px 1fr 32px",
                    alignItems: "center",
                    gap: 4,
                    fontWeight: 700,
                    fontSize: 20,
                  }}
                >
                  <button
                    type="button"
                    onClick={() => {
                      if (availableModules.length <= 1) return;
                      const index = availableModules.indexOf(activeModule);
                      const previous = availableModules[(index - 1 + availableModules.length) % availableModules.length];
                      switchModule(previous);
                    }}
                    disabled={availableModules.length <= 1}
                    title="Vorige menubalk"
                    style={{
                      border: "none",
                      background: "transparent",
                      color: "white",
                      fontSize: 22,
                      cursor: availableModules.length <= 1 ? "default" : "pointer",
                      opacity: availableModules.length <= 1 ? 0 : 1,
                      padding: 0,
                      lineHeight: 1,
                    }}
                  >
                    &lt;
                  </button>

                  <button
                    type="button"
                    onClick={() => setCompanySelectorOpen(true)}
                    title="Bedrijfscode-selectie"
                    style={{
                      border: "1px solid rgba(255,255,255,0.25)",
                      borderRadius: 8,
                      background: "rgba(255,255,255,0.08)",
                      color: "white",
                      padding: "6px 4px",
                      fontWeight: 700,
                      cursor: "pointer",
                      lineHeight: 1.15,
                    }}
                  >
                    <div>{activeModule}</div>
                    <div style={{ fontSize: 10, opacity: 0.8, marginTop: 2 }}>
                      {selectedCompanyCodeText()}
                    </div>
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      if (availableModules.length <= 1) return;
                      const index = availableModules.indexOf(activeModule);
                      const next = availableModules[(index + 1) % availableModules.length];
                      switchModule(next);
                    }}
                    disabled={availableModules.length <= 1}
                    title="Volgende menubalk"
                    style={{
                      border: "none",
                      background: "transparent",
                      color: "white",
                      fontSize: 22,
                      cursor: availableModules.length <= 1 ? "default" : "pointer",
                      opacity: availableModules.length <= 1 ? 0 : 1,
                      padding: 0,
                      lineHeight: 1,
                    }}
                  >
                    &gt;
                  </button>
                </div>
              </div>

    <nav style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                {isCrmModule && (
                  <>
                    <NavItem to="/organisaties"><MenuLabel icon="📁" text="Relaties" /></NavItem>
                    <NavItem to="/contactpersonen"><MenuLabel icon="👥" text="Contactpersonen" /></NavItem>
                    <NavItem to="/notities-taken"><MenuLabel icon="📝" text="Notities/Taken" /></NavItem>
                    <NavItem to="/documenten"><MenuLabel icon="🗂" text="Documenten" /></NavItem>
                  </>
                )}

                {isMkbModule && (
                  <>
                    <NavItem to="/organisaties"><MenuLabel icon="📁" text="Relaties" /></NavItem>
                    <NavItem to="/contactpersonen"><MenuLabel icon="👥" text="Contactpersonen" /></NavItem>
                    <NavItem to="/notities-taken"><MenuLabel icon="📝" text="Notities/Taken" /></NavItem>
                    <NavItem to="/offertes">
                      <MenuLabel icon="🧾" text="Offertes/" subText="Opdrachten" subTextSameStyle />
                    </NavItem>
                    <NavItem to="/werkbonnen"><MenuLabel icon="🛠" text="Werkbonnen" /></NavItem>
                    <NavItem to="/facturen"><MenuLabel icon="📄" text="Facturen" /></NavItem>
                    <NavItem to="/opdrachtvoortgang"><MenuLabel icon="📊" text="Opdr.voortgang" /></NavItem>
                    <NavItem to="/opdrachtenplanning"><MenuLabel icon="🗓" text="Opdr.planning" /></NavItem>
                    <NavItem to="/documenten"><MenuLabel icon="🗂" text="Documenten" /></NavItem>
                    <NavItem to="/projectbeheer"><MenuLabel icon="🧱" text="Projectbeheer" /></NavItem>
                    <NavItem to="/personeel"><MenuLabel icon="👤" text="Personeel" /></NavItem>
                  </>
                )}

                {isHrmModule && (
                  <>
                    <NavItem to="/organisaties"><MenuLabel icon="📁" text="Relaties" /></NavItem>
                    <NavItem to="/contactpersonen"><MenuLabel icon="👥" text="Contactpersonen" /></NavItem>
                    <NavItem to="/personeel"><MenuLabel icon="👤" text="Personeel" /></NavItem>
                    <NavItem to="/notities-taken"><MenuLabel icon="📝" text="Notities/Taken" /></NavItem>
                    <NavItem to="/opdrachten"><MenuLabel icon="📦" text="Opdrachten" /></NavItem>
                    <NavItem to="/aanvragen"><MenuLabel icon="📋" text="Aanvragen" /></NavItem>
                    <NavItem to="/vacatures"><MenuLabel icon="📣" text="Vacatures" /></NavItem>
                    <NavItem to="/plaatsingen"><MenuLabel icon="🤝" text="Plaatsingen" /></NavItem>
                    <NavItem to="/beschikbaarheid"><MenuLabel icon="🌡" text="Beschikbaarheid" /></NavItem>
                    <NavItem to="/planning"><MenuLabel icon="🗓" text="Planning" /></NavItem>
                    <NavItem to="/matching-personeel"><MenuLabel icon="🎯" text="Match Personeel" /></NavItem>
                    <NavItem to="/matching-relaties"><MenuLabel icon="🎯" text="Match Relaties" /></NavItem>
                    <NavItem to="/documenten"><MenuLabel icon="🗂" text="Documenten" /></NavItem>
                  </>
                )}

                {activeModule === "ERP" && (
                  <div
                    style={{
                      padding: "10px 12px",
                      border: "1px solid rgba(255,255,255,0.22)",
                      borderRadius: 8,
                      fontSize: 13,
                      lineHeight: 1.45,
                      opacity: 0.9,
                    }}
                  >
                    ERP-menu is nog in ontwikkeling.
                  </div>
                )}
              </nav>

            </div>

    <div style={{ marginTop: 6, display: "flex", flexDirection: "column", gap: 6 }}>
    <nav style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <NavItem to="/actiecentrum">
                  <MenuLabel icon="🔔" text={<span>Actiecentrum {actionCenterCount > 0 && <b style={{background:"#d93025",color:"white",borderRadius:12,padding:"2px 7px",marginLeft:6,fontSize:12}}>{actionCenterCount}</b>}</span>} />
                </NavItem>
                <NavItem to="/mijn-actiesignalen"><MenuLabel icon="🔔" text="Mijn Actiesignalen" /></NavItem>
                {isHrmModule && (
                  <NavItem to="/caos"><MenuLabel icon="📚" text="CAO's" /></NavItem>
                )}
                <NavItem to="/help">
                  <MenuLabel icon="❓" text="Help" />
                </NavItem>

                {isAdmin && (
                  <NavItem to="/instellingen">
                    <MenuLabel icon="⚙" text="Instellingen" />
                  </NavItem>
                )}
              </nav>

    <button
      onClick={() => {
        setMenuOpen(false);
        onLogout();
      }}
      style={{
        color: "white",
        textDecoration: "none",
        padding: "6px 12px",
        borderRadius: 6,
        background: "transparent",
        display: "block",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "left",
        border: "none",
        cursor: "pointer",
        font: "inherit",
      }}
                title="Uitloggen"
              >
                🚪 Uitloggen
              </button>
            </div>

          </aside>

          {companySelectorOpen && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                zIndex: 1500,
                background: "rgba(0,0,0,0.42)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 18,
                boxSizing: "border-box",
              }}
              onClick={() => setCompanySelectorOpen(false)}
            >
              <div
                style={{
                  width: "min(560px, 96vw)",
                  maxHeight: "86vh",
                  overflowY: "auto",
                  background: "white",
                  color: "#111",
                  borderRadius: 14,
                  boxShadow: "0 20px 55px rgba(0,0,0,0.30)",
                  padding: 20,
                  boxSizing: "border-box",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <h2 style={{ marginTop: 0, marginBottom: 6 }}>
                  Bedrijfscode-selectie
                </h2>

                <div style={{ marginBottom: 14, opacity: 0.75, lineHeight: 1.5 }}>
                  Deze selectie geldt voor {activeModule} en alle andere onderdelen van StaffIQ.
                  De laatst gekozen selectie wordt per gebruiker onthouden.
                </div>

                {companySelectorError && (
                  <div style={{
                    marginBottom: 10,
                    padding: "9px 11px",
                    background: "#fff0f0",
                    color: "#9b1c1c",
                    border: "1px solid #f2b8b8",
                    borderRadius: 6,
                  }}>
                    {companySelectorError}
                  </div>
                )}

                {companySelectorFlash && (
                  <div style={{
                    marginBottom: 10,
                    padding: "9px 11px",
                    background: "#eaf7ea",
                    color: "#1f6b1f",
                    border: "1px solid #b7dfb7",
                    borderRadius: 6,
                  }}>
                    {companySelectorFlash}
                  </div>
                )}

                <div style={{ display: "flex", gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
                  <button
                    type="button"
                    onClick={() => setSelectedCompanyCodeIds(companyCodes.filter((c) => c?.active !== false).map((c) => String(c.id)))}
                    style={{
                      padding: "8px 10px",
                      border: "1px solid #d9e2ec",
                      borderRadius: 6,
                      background: "white",
                      cursor: "pointer",
                    }}
                  >
                    Alle toegestane
                  </button>

                  <button
                    type="button"
                    onClick={loadCompanyScope}
                    style={{
                      padding: "8px 10px",
                      border: "1px solid #d9e2ec",
                      borderRadius: 6,
                      background: "white",
                      cursor: "pointer",
                    }}
                  >
                    Vernieuw
                  </button>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  {companyCodes.filter((c) => c?.active !== false).map((code) => {
                    const checked = selectedCompanyCodeIds.map(String).includes(String(code.id));

                    return (
                      <label
                        key={code.id}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "26px 1fr auto",
                          gap: 8,
                          alignItems: "center",
                          padding: "10px 12px",
                          border: "1px solid #d9e2ec",
                          borderRadius: 8,
                          background: checked ? "#f3f8ff" : "white",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={() => toggleCompanyCode(code.id)}
                        />
                        <span>
                          <b>{companyCodeLabel(code)}</b>
                          {!code.active && (
                            <span style={{ marginLeft: 8, color: "#999" }}>(inactief)</span>
                          )}
                        </span>
                        <span style={{ fontSize: 12, opacity: 0.65 }}>
                          {code.role || ""}
                        </span>
                      </label>
                    );
                  })}

                  {!companyCodes.length && (
                    <div style={{ padding: 12, opacity: 0.75 }}>
                      Geen bedrijfscodes gevonden.
                    </div>
                  )}
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 18 }}>
                  <button
                    type="button"
                    onClick={() => setCompanySelectorOpen(false)}
                    style={{
                      padding: "10px 14px",
                      border: "1px solid #ccc",
                      borderRadius: 6,
                      background: "white",
                      cursor: "pointer",
                    }}
                  >
                    Sluiten
                  </button>

                  <button
                    type="button"
                    onClick={async () => {
                      await saveCompanyScope();
                      setCompanySelectorOpen(false);
                    }}
                    disabled={!selectedCompanyCodeIds.length}
                    style={{
                      padding: "10px 14px",
                      border: "none",
                      borderRadius: 6,
                      background: "#1f4e79",
                      color: "white",
                      cursor: selectedCompanyCodeIds.length ? "pointer" : "not-allowed",
                      opacity: selectedCompanyCodeIds.length ? 1 : 0.55,
                    }}
                  >
                    Toepassen
                  </button>
                </div>
              </div>
            </div>
          )}


          <main
            ref={mainRef}
            style={{
              flex: "1 1 auto",
              minWidth: 0,
              padding: isMobile ? "56px 12px 12px 12px" : 24,
              background: "#f6f6f6",
              boxSizing: "border-box",
              height: "100dvh",
              overflowY: "auto",
              marginLeft: isMobile ? 0 : 0,
              width: "100%",
            }}
          >
            {children}
          </main>
        </div>
      );
    }

    function MenuLabel({ icon, text, subText, subTextSameStyle = false }) {
      return (
        <span
          style={{
            display: "grid",
            gridTemplateColumns: "26px 1fr",
            alignItems: "start",
            columnGap: 0,
            lineHeight: 1.05,
          }}
        >
          <span style={{ width: 26, textAlign: "left" }}>{icon}</span>
          <span style={{ display: "flex", flexDirection: "column" }}>
            <span>{text}</span>
            {subText && (
              <span
                style={
                  subTextSameStyle
                    ? { fontSize: "inherit", opacity: 1 }
                    : { fontSize: 12, opacity: 0.7 }
                }
              >
                {subText}
              </span>
            )}
          </span>
        </span>
      );
    }

    function NavItem({ to, children }) {
      return (
        <NavLink
          to={to}
          style={({ isActive }) => ({
            color: "white",
            textDecoration: "none",
            padding: "10px 12px",
            borderRadius: 8,
            background: isActive ? "#1e4e6a" : "transparent",
            display: "block",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: 16,
          })}
          title={typeof children === "string" ? children : undefined}
        >
          {children}
        </NavLink>
      );
    }

    function tenantFromHostname() {
      try {
        const host = String(window.location.hostname || "").toLowerCase().trim();

        if (!host) return "";

        // Lokaal en IP-adressen blijven werken zoals eerder: standaard demo,
        // of de tenant die al in de browser opgeslagen staat.
        if (
          host === "localhost" ||
          host === "127.0.0.1" ||
          /^\d+\.\d+\.\d+\.\d+$/.test(host)
        ) {
          return (
            sessionStorage.getItem("tenant") ||
            localStorage.getItem("tenant") ||
            "demo"
          );
        }

        if (host === "crm.staffiq.nl") return "demo";
        if (host === "login.staffiq.nl") return "";
        if (host === "staffiq.nl" || host === "www.staffiq.nl") return "demo";

        if (host.endsWith(".staffiq.nl")) {
          const subdomain = host.split(".")[0];

          if (subdomain && !["www", "crm", "login"].includes(subdomain)) {
            return subdomain;
          }
        }

        return (
          sessionStorage.getItem("tenant") ||
          localStorage.getItem("tenant") ||
          "demo"
        );
      } catch {
        return "demo";
      }
    }

    function syncTenantFromHostname() {
      const tenant = tenantFromHostname();

      if (!tenant) return "";

      try {
        const host = String(window.location.hostname || "").toLowerCase().trim();
        const isTenantSubdomain =
          host.endsWith(".staffiq.nl") &&
          !["crm.staffiq.nl", "www.staffiq.nl", "login.staffiq.nl"].includes(host);

        // Op tenant-subdomeinen altijd de juiste tenant klaarzetten.
        // Op localhost/IP bewaren we de bestaande keuze.
        if (isTenantSubdomain || !sessionStorage.getItem("tenant")) {
          sessionStorage.setItem("tenant", tenant);
        }

        if (isTenantSubdomain || !localStorage.getItem("tenant")) {
          localStorage.setItem("tenant", tenant);
        }
      } catch {}

      return tenant;
    }

    // -------------------- ACTIVITY LOG HELPERS --------------------

    function getStoredUserForActivity() {
      try {
        const raw =
          sessionStorage.getItem("user") ||
          localStorage.getItem("user") ||
          "";

        return raw ? JSON.parse(raw) : null;
      } catch {
        return null;
      }
    }

    function getActivitySessionKey() {
      const user = getStoredUserForActivity();

      return (
        sessionStorage.getItem("session_key") ||
        localStorage.getItem("session_key") ||
        user?.session_key ||
        ""
      );
    }

    function getActivityTenant() {
      const user = getStoredUserForActivity();

      return (
        sessionStorage.getItem("tenant") ||
        localStorage.getItem("tenant") ||
        user?.tenant ||
        tenantFromHostname() ||
        "demo"
      );
    }

    function buildActivityHeaders() {
      const user = getStoredUserForActivity();
      const sessionKey = getActivitySessionKey();

      const headers = {};

      if (sessionKey) headers["x-session-key"] = sessionKey;
      if (getActivityTenant()) headers["x-tenant"] = getActivityTenant();

      if (user?.id) headers["x-staffiq-user-id"] = String(user.id);
      if (user?.email) headers["x-staffiq-user-email"] = String(user.email);
      if (user?.display_name || user?.name) {
        headers["x-staffiq-user-name"] = String(user.display_name || user.name);
      }
      if (user?.role) headers["x-role"] = String(user.role);

      const companyScope =
        sessionStorage.getItem("staffiq_company_code_ids") ||
        localStorage.getItem("staffiq_company_code_ids") ||
        "";

      if (companyScope) headers["x-company-code-ids"] = companyScope;

      return headers;
    }

    async function sendActivityHeartbeat() {
      const sessionKey = getActivitySessionKey();
      if (!sessionKey) return;

      try {
        await fetch("/api/activity-log/heartbeat", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...buildActivityHeaders(),
          },
          body: JSON.stringify({
            session_key: sessionKey,
          }),
        });
      } catch {
        // bewust stil: logboek mag het systeem nooit blokkeren
      }
    }

    async function sendActivityLogout() {
      const sessionKey = getActivitySessionKey();
      if (!sessionKey) return;

      try {
        await fetch("/api/activity-log/logout", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...buildActivityHeaders(),
          },
          body: JSON.stringify({
            session_key: sessionKey,
            reason: "logout",
          }),
        });
      } catch {
        // bewust stil: uitloggen mag nooit blokkeren
      }
    }

    export default function App() {

    syncTenantFromHostname();

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    const [staffiqProfile, setStaffiqProfile] = useState("ALL");

    useEffect(() => {
      const token = sessionStorage.getItem("token");
      const rawUser = sessionStorage.getItem("user");

      if (token) setIsLoggedIn(true);

      try {
        const parsedUser = rawUser ? JSON.parse(rawUser) : null;

        if (parsedUser?.session_key) {
          sessionStorage.setItem("session_key", parsedUser.session_key);
          localStorage.setItem("session_key", parsedUser.session_key);
        }

        setCurrentUser(parsedUser);
      } catch {
        setCurrentUser(null);
      }
    }, []);

    useEffect(() => {
      if (!isLoggedIn) return;

      // Bij starten direct één heartbeat, daarna elke 2 minuten.
      sendActivityHeartbeat();

      const timer = window.setInterval(() => {
        sendActivityHeartbeat();
      }, 120000);

      return () => {
        window.clearInterval(timer);
      };
    }, [isLoggedIn, currentUser?.id]);

    useEffect(() => {
      if (!isLoggedIn) return;

      // Deze patch zorgt dat toekomstige API-calls automatisch
      // gebruiker + sessie meesturen naar server.js.
      // GET blijft op de server buiten het gewone logboek,
      // dus dit geeft nauwelijks extra ballast.
      const originalFetch = window.fetch;

      if (window.__staffiqActivityFetchPatched) return;

      window.__staffiqActivityFetchPatched = true;

      window.fetch = (input, init = {}) => {
        try {
          const url =
            typeof input === "string"
              ? input
              : input?.url || "";

          const shouldAddHeaders =
            String(url || "").startsWith("/api/") ||
            String(url || "").includes("localhost:3001/api/");

          if (!shouldAddHeaders) {
            return originalFetch(input, init);
          }

          const existingHeaders = init?.headers || {};

          const mergedHeaders = {
            ...(existingHeaders || {}),
            ...buildActivityHeaders(),
          };

          return originalFetch(input, {
            ...init,
            headers: mergedHeaders,
          });
        } catch {
          return originalFetch(input, init);
        }
      };

      return () => {
        try {
          window.fetch = originalFetch;
          window.__staffiqActivityFetchPatched = false;
        } catch {}
      };
    }, [isLoggedIn, currentUser?.id]);

    const handleLogin = () => {
      setIsLoggedIn(true);

      try {
        const rawUser = sessionStorage.getItem("user");
        const parsedUser = rawUser ? JSON.parse(rawUser) : null;

        if (parsedUser?.session_key) {
          sessionStorage.setItem("session_key", parsedUser.session_key);
          localStorage.setItem("session_key", parsedUser.session_key);
        }

        setCurrentUser(parsedUser);
      } catch {
        setCurrentUser(null);
      }
    };

    const handleLogout = async () => {
      await sendActivityLogout();

      sessionStorage.removeItem("token");
      sessionStorage.removeItem("tenant");
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("session_key");

      localStorage.removeItem("token");
      localStorage.removeItem("tenant");
      localStorage.removeItem("user");
      localStorage.removeItem("session_key");

      sessionStorage.removeItem("staffiq_company_code_ids");
      localStorage.removeItem("staffiq_company_code_ids");

      setIsLoggedIn(false);
      setCurrentUser(null);
    };


    useEffect(() => {
      if (!isLoggedIn) return;

      let cancelled = false;

      async function loadStaffiqProfile() {
        try {
          const res = await fetch("/api/general-settings", {
            headers: {
              "Content-Type": "application/json",
              ...buildActivityHeaders(),
            },
          });

          const data = await res.json().catch(() => ({}));
          if (!res.ok) throw new Error(data?.error || "Profiel laden mislukt.");

          if (!cancelled) {
            setStaffiqProfile(String(data?.staffiq_profile || "ALL").toUpperCase());
          }
        } catch {
          if (!cancelled) setStaffiqProfile("ALL");
        }
      }

      loadStaffiqProfile();

      function onProfileChanged(event) {
        const next = String(event?.detail?.staffiq_profile || "ALL").toUpperCase();
        setStaffiqProfile(next);
      }

      window.addEventListener("staffiq-profile-changed", onProfileChanged);

      return () => {
        cancelled = true;
        window.removeEventListener("staffiq-profile-changed", onProfileChanged);
      };
    }, [isLoggedIn, currentUser?.id]);

    const isPublicApprovalRoute = (() => {
      const path = String(window.location.pathname || "").toLowerCase();
      return path.startsWith("/akkoord/") || path.startsWith("/approval/");
    })();

    if (isPublicApprovalRoute) {
      return (
        <BrowserRouter>
          <Routes>
            <Route path="/akkoord/:token" element={<Akkoord />} />
            <Route path="/approval/:token" element={<Akkoord />} />
          </Routes>
        </BrowserRouter>
      );
    }

    if (!isLoggedIn) {
      return <Login onLogin={handleLogin} />;
    }

    return (
      <>
        <BrowserRouter>
          <Layout onLogout={handleLogout} currentUser={currentUser} staffiqProfile={staffiqProfile}>
            <Routes>
              <Route path="/" element={<Organisaties staffiqProfile={staffiqProfile} />} />
              <Route path="/organisaties" element={<Organisaties staffiqProfile={staffiqProfile} />} />
              <Route path="/organisaties/:id" element={<OrganisatieDetail />} />
              <Route path="/contactpersonen" element={<Contactpersonen />} />
              <Route path="/notities-taken" element={<NotitiesTaken />} />
              <Route path="/documenten" element={<Documenten />} />
              <Route path="/projectbeheer" element={<Projectbeheer />} />
              <Route path="/offertes" element={<Offertes />} />
              <Route path="/facturen" element={<Facturen />} />
              <Route path="/werkbon-oplevering/:offerId" element={<WerkbonOplevering />} />
              <Route path="/werkbonnen" element={<WerkbonnenOverzicht />} />
              <Route path="/opdrachtvoortgang" element={<Opdrachtvoortgang />} />
              <Route path="/opdrachtenplanning" element={<Opdrachtenplanning />} />
              <Route
                path="/instellingen"
                element={
                  (currentUser?.role || "").toLowerCase() === "admin"
                    ? <Instellingen />
                    : <Help staffiqProfile={staffiqProfile} />
                }
              />
              <Route path="/personeel" element={<Personeel />} />
              <Route path="/matching-personeel" element={<MatchingPersoneel />} />
              <Route path="/matching-relaties" element={<MatchingRelaties />} />
              <Route path="/opdrachten" element={<Opdrachten />} />
              <Route path="/aanvragen" element={<Aanvragen />} />
              <Route path="/vacatures" element={<Vacatures />} />
              <Route path="/plaatsingen" element={<Plaatsingen />} />
              <Route path="/caos" element={<CAOs />} />
              <Route path="/planning" element={<Planning />} />
              <Route path="/beschikbaarheid" element={<Beschikbaarheid />} />
              <Route path="/akkoord/:token" element={<Akkoord />} />
              <Route path="/approval/:token" element={<Akkoord />} />
              <Route path="/actiecentrum" element={<Actiecentrum />} />
              <Route path="/mijn-actiesignalen" element={<MijnActiesignalen />} />
              <Route path="/help" element={<Help staffiqProfile={staffiqProfile} />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </>
    );
    }
